export var LeaderboardDuration;
(function (LeaderboardDuration) {
    LeaderboardDuration["Day"] = "day";
    LeaderboardDuration["Week"] = "week";
    LeaderboardDuration["Month"] = "month";
})(LeaderboardDuration || (LeaderboardDuration = {}));
export var LeaderboardType;
(function (LeaderboardType) {
    LeaderboardType["PARC"] = "parc";
    LeaderboardType["PART"] = "part";
})(LeaderboardType || (LeaderboardType = {}));
export var LeaderboardRewardType;
(function (LeaderboardRewardType) {
    LeaderboardRewardType["PARC"] = "parc";
    LeaderboardRewardType["PART"] = "part";
    LeaderboardRewardType["ALEO"] = "aleo";
})(LeaderboardRewardType || (LeaderboardRewardType = {}));
export const getLeaderboardRewardAmount = (rank, reward) => {
    return reward.rewards[rank - 1];
};
